export const UserUrl = {
  USER: '/user{/id}{?page,size,sort*,search,username,firstName,lastName,roles,validFrom,validTo,lock,isAdmin,isSuperadmin,groupId,accessGroupId}',
  SEARCH_NEW: '/user/searchNew{?username}',
  SEARCH_DATA_MANAGERS: '/user/searchDataManagers{?search}',
  SEARCH_EXISTING: '/user/searchExisting{?searchText,page,size}',
  ROLE: '/user/role',
};
